import consumer from './consumer'

// Get the token to initialize connection
const url = new URL(window.location)
const search_params = url.searchParams

// Get the path to redirect later
const estimate_url = document.getElementById('path').dataset.url

export default function createEstimateSubscription() {
  consumer.subscriptions.create({
    channel: 'EstimateChannel',
    token  : search_params.get('token')
  }, {
    connected() {
    // Called when the subscription is ready for use on the server
    },

    disconnected() {
    // Called when the subscription has been terminated by the server
    },

    received(data) {
    // Called when there's incoming data on the websocket for this channel
      window.location = estimate_url.replace('slug', data.body)
    }
  })
}